import React from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import App from './../App';

import '../components/NavBar.css';

import Error404  from '../paginas/Error404';

const Router = () => {
	return (
		<div className="contenedor">
			
			<BrowserRouter>
				<Switch>
				  
					<Route path="/"          component={App} />
					<Route path="/*"         component={Error404}/>
				</Switch>
			</BrowserRouter>
		</div>
	);
}
 
export default Router;